<template>
  <div :class="[classDiv, 'placeholder-glow']">
    <div :class="['form-floating', (btn_lock ? 'input-group' : ''), 'mb-3']">
      <input :type="tipo_alterado" :multiple="multiple" :class="['form-control', tam_input, class_placeholder]"
        :name="nome_input" :id="nome_input" :aria-describedby="id_descr" :placeholder="placeholder" :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)" :disabled="desabilitado" :required="required" />
      <button class="btn btn-secondary rounded" type="button" v-if="btn_lock" @click="tipo_alterado = (tipo_alterado == 'text' ? 'password' : 'text')">
        <i :class="['bi', 'bi-'+(tipo_alterado == 'text' ? 'unlock' : 'lock')]"></i>
      </button>
      <p>
        <tooltips>
          <span v-html="btn_tooltip"></span>
        </tooltips>
      </p>
      <label :for="(nome_input ? nome_input : '')" v-if="label" class="form-label text-secondary">
        {{ label }}
      </label>
      <div :id="id_descr" v-if="descricao" class="form-text">
        {{ descricao }}
      </div>
    </div>
  </div>
</template>

<script>
import Tooltips from '../Tooltips.vue';
export default {
  name: "InputText",
  props: {
    tipo: {
      default: "text",
    },
    tamanho: {
      default: "",
    },
    nome: {
      default: "nome",
    },
    desabilitado: {
      default: false,
    },
    ativa_placeholder: {
      default: false,
    },
    multiple: {
      default: false,
    },
    placeholder: {
      default: ' '
    },
    btn_lock: {
      default: false,
    },
    required: {
      default: false,
    },
    modelValue: '',
    classDiv: String,
    label: String,
    id: String,
    id_descr: String,
    descricao: String,
    tooltip: String,
    tooltip_direcao: {
      default: "top",
    },
  },
  emits: ['update:modelValue'],
  components: { Tooltips },
  data() {
    return {
      model: "",
      tipo_alterado: this.tipo,
    };
  },
  computed: {
    tam_input: function () {
      if (this.tamanho == "") {
        return "";
      } else {
        return "form-control-" + this.tamanho;
      }
    },
    btn_tooltip: function () {
      if (this.tooltip != undefined) {
        return `<button type="button" class="border-0" data-bs-toggle="tooltip" data-bs-placement="` + this.tooltip_direcao + `"
                  data-bs-title="`+ this.tooltip + `">
                  <i class="bi bi-info-circle"></i>
                </button>`
      }
    },
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '')
    },
    nome_input: function () {
      return (this.multiple ? this.nome + `[]` : this.nome)
    }
  },
  mounted() {

  },
};
</script>

<style scoped>
label {
  font-size: 1rem !important;
  color: #999 !important;
}
</style>